<template>
  <base-form
    v-slot="slotProps"
    :model="settings"
    :rules="rules"
    :loading="loading"
    :form-submitted="formSubmitted"
    :submit-label="submitLabel"
    mode="edit"
  >
    <el-form-item
      label="Textbaustein Anbieter"
      prop="organization_signup_snippet"
    >
      <el-input
        v-model="slotProps.model.organization_signup_snippet"
        type="textarea"
        :rows="5"
      ></el-input>
    </el-form-item>

    <label class="el-form-item__label"
      >Textbaustein Impressum Herausgeber</label
    >
    <text-editor
      v-model="slotProps.model.imprint_editor_snippet"
      :loading="loading"
      :allow-lists="false"
      :allow-headings="false"
    ></text-editor>

    <label class="el-form-item__label"
      >Textbaustein Impressum inhaltlich verantwortlich</label
    >
    <text-editor
      v-model="slotProps.model.imprint_content_snippet"
      :loading="loading"
      :allow-lists="false"
      :allow-headings="false"
    ></text-editor>

    <label class="el-form-item__label"
      >Textbaustein Impressum Bild-/Grafikrechte</label
    >
    <text-editor
      v-model="slotProps.model.images_legal_snippet"
      :loading="loading"
      :allow-lists="false"
      :allow-headings="false"
    ></text-editor>

    <label class="el-form-item__label"
      >Textbaustein Datenschutz Verantwortliche & Ansprechpartner</label
    >
    <text-editor
      v-model="slotProps.model.privacy_snippet"
      :loading="loading"
      :allow-lists="false"
      :allow-headings="false"
    ></text-editor>

    <label class="el-form-item__label"
      >Textbaustein Unterseite Barrierefreiheit</label
    >
    <text-editor
      v-model="slotProps.model.accessibility_snippet"
      :loading="loading"
      :allow-lists="true"
      :allow-headings="true"
    ></text-editor>

    <el-form-item
      label="Textbaustein Meta Description"
      prop="meta_description_snippet"
    >
      <el-input
        v-model="slotProps.model.meta_description_snippet"
        type="textarea"
        :rows="5"
        :maxlength="160"
        show-word-limit
      ></el-input>
    </el-form-item>
  </base-form>
</template>

<script>
import BaseForm from "@/components/forms/BaseForm"
import TextEditor from "@/components/TextEditor"

export default {
  components: {
    BaseForm,
    TextEditor
  },
  props: {
    settings: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    submitLabel: {
      type: String,
      default: "Änderungen speichern"
    },
    formSubmitted: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      rules: {
        organization_signup_snippet: [
          { required: true, message: "Bitte ausfüllen", trigger: "blur" }
        ]
      }
    }
  }
}
</script>
